import * as navigation from 'Navigation';

export default class ProcessDetailsTabState extends navigation.TabState {
  override defaults(): navigation.TabStateDefaults {
    return {
      ...super.defaults(),
      title: 'Task Group',
      closeable: false,
      preferenceKey: 'process-details',
    };
  }
}
